import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Mail = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M4.0716 20.2031c-.6296 0-1.1662-.2217-1.6097-.6652s-.6653-.9801-.6653-1.6098V6.0716c0-.6296.2218-1.1662.6653-1.6097s.98-.6653 1.6097-.6653h15.8565c.6297 0 1.1663.2218 1.6098.6653s.6652.98.6652 1.6097v11.8565c0 .6297-.2217 1.1663-.6652 1.6098s-.9801.6652-1.6098.6652H4.0716zM12 13.0521c.0993 0 .2007-.0145.3042-.0435a1.1873 1.1873 0 00.2985-.1305l6.8898-4.3472a.8901.8901 0 00.3207-.3305c.0767-.137.115-.2884.115-.4543 0-.3573-.1546-.6282-.4637-.8127-.3094-.1847-.6279-.1753-.9558.028l-6.5087 4.1102-6.5088-4.1102c-.3238-.1993-.6414-.2065-.9527-.0215-.3112.185-.4668.4537-.4668.8062 0 .1825.0384.3413.115.4763a.7642.7642 0 00.3208.3085l6.8897 4.3472c.0954.058.1949.1015.2985.1305.1035.029.2049.0435.3043.0435z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M4.0716 20.2031c-.6296 0-1.1662-.2217-1.6097-.6652s-.6653-.9801-.6653-1.6098V6.0716c0-.6296.2218-1.1662.6653-1.6097s.98-.6653 1.6097-.6653h15.8565c.6297 0 1.1663.2218 1.6098.6653s.6652.98.6652 1.6097v11.8565c0 .6297-.2217 1.1663-.6652 1.6098s-.9801.6652-1.6098.6652H4.0716zM19.9281 8.2569l-7.3255 4.6212a1.1651 1.1651 0 01-.2977.1305 1.1329 1.1329 0 01-.305.0435c-.0994 0-.201-.0145-.305-.0435a1.1658 1.1658 0 01-.2978-.1305L4.0716 8.2569v9.6712h15.8565V8.2569zm-7.9282 2.8147l7.9282-5H4.0716l7.9283 5zM4.0716 8.5309V6.9326v.0278-.8888.8898-.0215 1.591z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M4.0716 20.2031c-.6296 0-1.1662-.2217-1.6097-.6652s-.6653-.9801-.6653-1.6098V6.0716c0-.6296.2218-1.1662.6653-1.6097s.98-.6653 1.6097-.6653h15.8565c.6297 0 1.1663.2218 1.6098.6653s.6652.98.6652 1.6097v11.8565c0 .6297-.2217 1.1663-.6652 1.6098s-.9801.6652-1.6098.6652H4.0716zM19.9281 8.2569l-7.3255 4.6212a1.1651 1.1651 0 01-.2977.1305 1.1329 1.1329 0 01-.305.0435c-.0994 0-.201-.0145-.305-.0435a1.1658 1.1658 0 01-.2978-.1305L4.0716 8.2569v9.6712h15.8565V8.2569zm-7.9282 2.8147l7.9282-5H4.0716l7.9283 5zM4.0716 8.5309V6.9326v.0278-.8888.8898-.0215 1.591z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Mail.displayName = "MailIcon";

export { Mail, Mail as default };
